<template>
  <div>
    <div v-if="type==='index'" class="work">
      <Header title="空闲教室查询" type='0' route='/homeIndex'></Header>
      <router-view></router-view>
      <van-tabbar
        class="bottom-nav"
        v-model="active"
        active-color="#7469F8"
        inactive-color="#B3B9D0"
        route
      >
        <van-tabbar-item icon="like-o" replace to="/kx_bindex">
          <span class="nav-title">我要查询</span>
        </van-tabbar-item>
        <van-tabbar-item icon="like" replace to="/student_bList">
          <span class="nav-title">借用记录</span>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <njkxRoom v-if="type==='njlyindex'" />
  </div>
</template>

<script>
import njkxRoom from '../njkxRooms/index.vue'
export default {
  components:{
    njkxRoom
  },
  data() {
    return {
      active: 0,
      type:''
    };
  },
  methods: {},
  created() {
    if(sessionStorage.getItem('schoolCode') === '10298'){
      this.type="njlyindex"
    }else{
      this.type="index"
    }
  }
};
</script>
<style lang="less" scoped>
.bottom-nav {
  width: 100%;
  height: 49px;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);

  .nav-title {
    width: 22px;
    height: 16px;
    font-family: PingFangSC-Regular;
    font-size: 11px;
    letter-spacing: 0;
    text-align: center;
  }
}
</style>
<style lang="less">
.bottom-nav {
  .van-icon-like,
  .van-icon-like-o {
    font-family: "iconfont" !important;
    font-size: 26px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .van-icon-like::before {
    content: "\e6b7";
  }
  .van-icon-like-o::before {
    content: "\e6c0";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/restRooms/borrowBar.vue